import classNames from 'classnames';

import { setupForDark } from '@theme';

export default function MasterLogo({ size = 32 }: { size: number }) {
  return (
    <div className={classNames(setupForDark('text-primary'))}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 32 32'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M25.3943 14.0639C29.0468 14.0639 32 11.0756 32 7.39603C32 3.71646 29.0434 0.735102 25.3943 0.735102C21.7453 0.735103 18.7956 3.71646 18.7956 7.39603C18.7956 11.0756 21.7522 14.0639 25.3943 14.0639ZM20.5717 30.999L29.7219 30.999C30.8367 30.999 31.7542 30.0774 31.7542 28.9428L31.7542 19.7159C31.7542 18.5848 30.8367 17.6597 29.7219 17.6597L20.5716 17.6597C19.4499 17.6597 18.5394 18.5848 18.5394 19.7159L18.5394 28.9428C18.5394 30.0739 19.4499 30.999 20.5717 30.999Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.29182 14.7832L12.4421 14.7832C13.7023 14.7832 14.7236 13.7499 14.7236 12.4756L14.7236 3.24877C14.7236 1.97803 13.7023 0.948167 12.4421 0.948167L3.29182 0.948168C2.03162 0.948168 1.0103 1.97803 1.0103 3.24877L1.0103 12.4756C1.0103 13.7464 2.03162 14.7832 3.29182 14.7832ZM2.7275 3.25226C2.7275 2.93108 2.98369 2.67624 3.29182 2.67624L12.4421 2.67624C12.7606 2.67624 13.0134 2.93457 13.0134 3.25226L13.0134 12.4791C13.0134 12.8003 12.7572 13.0551 12.4421 13.0551L3.29182 13.0551C2.98023 13.0551 2.7275 12.7968 2.7275 12.4791L2.7275 3.25226Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.67534 31.1348C11.4629 31.1348 14.5303 28.0347 14.5303 24.2155C14.5303 20.3963 11.4629 17.3032 7.67534 17.3032C3.88782 17.3032 0.820408 20.3963 0.820408 24.2155C0.820409 28.0347 3.89474 31.1348 7.67534 31.1348ZM7.67534 19.0278C10.5143 19.0278 12.82 21.3563 12.82 24.2155C12.82 27.0747 10.5108 29.4032 7.67534 29.4032C4.83989 29.4032 2.5376 27.0817 2.5376 24.2155C2.5376 21.3494 4.83989 19.0278 7.67534 19.0278Z'
          fill='currentColor'
        />
      </svg>
    </div>
  );
}
